<template>
  <div class="map-container">
    {{ linkedMap ? '' : '' }}
    <div v-if="showFilterInfo" class="filter-display">
      {{ filterBarDisplay }}
      <span v-if="!viewingFilters">
        <span class="update-filters-link pointer" @click="enableFilterView()"
          >Update Filter
        </span>
      </span>
    </div>
    <div v-if="showRequestLimitError" class="limit-error">
      <img :src="require(`@/assets/img/alert-ico.svg`)" />
      <div>
      <p class="header">Site Request Limit Alert (5000+ sites requested)</p>
      <div>
        <span>The request you provided generated too many results. Please zoom into an area of interest and try again.</span>
      </div>
      </div>
    </div>
    <div v-if="showRenderLimitError" class="limit-error">
      <div class="image-container">
      <img :src="require(`@/assets/img/alert-ico.svg`)" />
      </div>
      <div>
      <p class="header">Map Performance Alert (5000+ sites in view)</p>
      <div>
        <span>There are currently too many sites to load for this user. Please filter or zoom into an area of interest to view relevant sites.</span>
      </div>
      <p class="clear-cache-link" @click="clearSites()">Clear my current cache of sites.</p>
      </div>
    </div>
    <div
      class="map"
      ref="googleMap"
      :style="{ height: `${this.height}px` }"
    ></div>

    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
        :clearBound="clearBound"
        :provideBound="provideBound"
        :fitBound="fitBound"
        :mapBounds="mapBounds"
        :sprayDataPoint="sprayDataPoint"
      />
    </template>
  </div>
</template>

<script>
import loadGoogleMaps from '@/utils/google-maps';
import Point from '../../store/models/point';
import loadGoogle from '../../utils/google-maps';

export default {
  props: {
    onFirstLoad: Function,
    handleKeyPress: Function,
    linkedMap: Object,
    showFilterInfo: Boolean,
    sprayDataPoint: Object,
    showNoSprayMarkersForSprayPaths: Boolean,
    showSprayReminderMarkersForSprayPaths: Boolean,
    selectedZone: Object,
    withMap: Function,
    zoom: {
      type: Number,
      default: 10,
    },
    draggable: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 800,
    },
    center: {
      type: Object,
      default: () => Point.default(),
    },
    topCenterButtonSettings: Object,
    onBoundsChanged: Function,
    showRequestLimitError: Boolean,
    showRenderLimitError: Boolean,
  },

  computed: {
    filterBarDisplay() {
      const mapState = this.$store.state.map;
      const visibleMappables = this.$store.getters.visibleMappables;
      const filterSettings = mapState.settings.filters;
      const zone = filterSettings.zones.selectedZone;
      const siteTypes = filterSettings.siteTypes;
      const activityTypes = filterSettings.activity;
      const allToggleTypes = { ...activityTypes, ...siteTypes };
      const enabledToggles = Object.keys(allToggleTypes).filter(
        (key) => allToggleTypes[key]
      );
      const totalMappables =
        mapState.activeMappables.length + mapState.inactiveMappables.length;
      const totalVisibleMappables = visibleMappables.length;
      const filterBarDisplay = [
        zone,
        enabledToggles.join(', '),
        `${totalVisibleMappables} out of ${totalMappables} sites`,
      ].join(' | ');
      return `Currently showing: ${filterBarDisplay}`;
    },
    viewingFilters() {
      return this.$store.state.map.settings.displayFilterSettings;
    },
    formattedCenter() {
      if (this.center.toObject) {
        return this.center.toObject();
      } else if (this.center.geometry) {
        return {
          lng: this.center.geometry.coordinates[0],
          lat: this.center.geometry.coordinates[1],
        };
      }
    },
    selectedMappable() {
      const { selectedMappable } = this.$store.state.map;
      return selectedMappable;
    },
  },

  data() {
    return {
      firstLoadComplete: false,
      hasZoomedOnSelectedMappable: false,
      google: null,
      map: null,
      google: null,
      bounds: null,
      provideBound: null,
      fitBound: null,
      displayedZonePolygon: null,
      previousSelectedZone: null,
      previousLinkedMap: null,
      topCenterButton: null,
      mapBounds: null,
    };
  },

  methods: {
    clearSites() {
      const { $store } = this;
      $store.commit('resetMappables');
      $store.commit('handleChangeFilters', {
        ...$store.state.map.settings.filters,
      });
    },
    enableFilterView() {
      this.$store.dispatch('setDisplayFilterSettings', true);
    },
    drawZone(zone) {
      this.displayedZonePolygon = new this.google.maps.Polygon({
        paths: zone.points,
        strokeColor: '#10b8a8',
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: '#0dd6c7',
        fillOpacity: 0.15,
      });
      this.displayedZonePolygon.zone = zone;
      this.displayedZonePolygon.setMap(this.map);
    },
    handleSelectedZone(zone) {
      if (zone.points.length > 0) {
        this.bounds = new this.google.maps.LatLngBounds();
        zone.points.forEach((point) => this.provideBound(point));
        this.fitBound();
      }

      if (!zone.id) {
        if (this.displayedZonePolygon) {
          this.displayedZonePolygon.setMap(null);
        }
        return;
      } else {
        if (this.displayedZonePolygon) {
          if (this.displayedZonePolygon.zone === zone) {
            this.displayedZonePolygon.setMap(this.map);
            return;
          } else {
            this.displayedZonePolygon.setMap(null);
          }
        }
        this.drawZone(zone);
      }
    },

    buildTopCenterButton(topCenterButtonSettings) {
      if(!topCenterButtonSettings) {
        return;
      }
      const $this = this;
      const centerControlDiv = document.createElement('div');

      const controlUI = document.createElement('div');
      controlUI.style.backgroundColor = '#fff';
      controlUI.style.borderRadius = '50px';
      controlUI.style.width= '200px';
      controlUI.style.height='31px';
      controlUI.style.boxShadow = '0 2px 6px rgba(0, 0, 0, .3)';
      controlUI.style.textAlign = 'center';
      controlUI.style.cursor = 'pointer';
      controlUI.style.marginTop = '12px';
      controlUI.addEventListener('focus', function () {
        this.style.backgroundColor = 'gray';
      });
      centerControlDiv.appendChild(controlUI);

      const controlText = document.createElement('div');
      controlText.style.color = '#4469ce';
      controlText.style.fontFamily=  'Roboto';
      controlText.style.fontSize='12px';
      controlText.style.fontWeight= 500;
      controlText.style.lineHeight= '31px';
      controlUI.appendChild(controlText);

      const {text, onClick} = topCenterButtonSettings;
      controlText.innerHTML = text;
      controlUI.addEventListener('click', () => onClick($this.map));

      return centerControlDiv;
    },

    setTopCenterButtonVisibility(visible) {
      this.topCenterButton.style.visibility = visible ? 'visible' : 'hidden';
    }
  },

  watch: {
    center: function(value) {
      if (this.map) {
        this.map.setCenter(this.formattedCenter);
      }
    },
    topCenterButtonSettings: function(value) {
      this.setTopCenterButtonVisibility(this.topCenterButtonSettings.visible);
    }
  },

  async mounted() {
    const $this = this;
    const onLoad = () => {
      $this.google = window.google;
      $this.bounds = new $this.google.maps.LatLngBounds();
      $this.map = new $this.google.maps.Map($this.$refs.googleMap, {
        disableDefaultUI: true,
        zoom: $this.zoom,
        center: $this.formattedCenter,
        draggable: $this.draggable,
        mapTypeControl: true,
        zoomControl: true,
        keyboardShortcuts: !$this.handleKeyPress,
      });

      $this.mapBounds = $this.map.getBounds();
      $this.map.addListener('center_changed', () => {
        let center = this.map.getCenter();
        localStorage.setItem('centerLng', center.lng());
        localStorage.setItem('centerLat', center.lat());
      });

      if ($this.handleKeyPress) {
        google.maps.event.addDomListener(document, 'keydown', function(e) {
          $this.handleKeyPress(e);
        });
      }

      $this.clearBound = function() {
        $this.bounds = new this.google.maps.LatLngBounds();
      };
      if ($this.withMap) {
        $this.withMap($this.map);
      }

      $this.provideBound = function(point) {
        const { bounds, google } = $this;
        const { LatLng } = google.maps;
        const latLngBound = new LatLng(point);
        bounds.extend(latLngBound);
      };

      $this.fitBound = function() {
        const { bounds, map } = $this;
        map.fitBounds(bounds);
      };

      const topCenterButton = $this.buildTopCenterButton($this.topCenterButtonSettings);
      $this.topCenterButton = topCenterButton;
      $this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(topCenterButton);

      const {onFirstLoad, topCenterButtonSettings, onBoundsChanged } = $this;

      if (onFirstLoad) {
        google.maps.event.addListener($this.map, 'tilesloaded', () => {
          if ($this.firstLoadComplete) {
            return;
          }
          $this.firstLoadComplete = true;
          $this.onFirstLoad($this.map);
        });
      }

      if(onBoundsChanged) {
        google.maps.event.addListener($this.map, 'dragend', () => {
          $this.mapBounds = $this.map.getBounds();
          onBoundsChanged(); 
        });
        google.maps.event.addListener($this.map, 'zoom_changed', () => {
          $this.mapBounds = $this.map.getBounds();
          onBoundsChanged(); 
        });
      }

    
    };
    loadGoogle(onLoad);
  },

  updated() {
    if (!this.google) {
      return;
    }
    if (this.linkedMap) {
      this.previousLinkedMap = this.linkedMap;
    } else if (this.previousLinkedMap) {
      this.previousLinkedMap.setZoom(this.map.getZoom());
      this.previousLinkedMap.setCenter(this.map.getCenter());
      this.previousLinkedMap = null;
    }
    if (this.selectedMappable) {
      if(!this.hasZoomedOnSelectedMappable) {
        const zoom = this.map.getZoom();
        this.bounds = new this.google.maps.LatLngBounds();
        this.selectedMappable.coordinates.forEach((point) =>
          this.provideBound(
            new Point(parseFloat(point.lat), parseFloat(point.lng || point.lon))
          )
        );
        this.fitBound();
        this.map.setZoom(zoom);
        this.hasZoomedOnSelectedMappable = true;
      return;
      }
    } else {
        this.hasZoomedOnSelectedMappable = false;
    }
    if (this.selectedZone && this.selectedZone !== this.previousSelectedZone) {
      this.handleSelectedZone(this.selectedZone);
      this.previousSelectedZone = this.selectedZone;
    }
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';

.map-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-height: 800px;
}

.map {
  width: 100%;
  height: 773px;
}

.filter-display {
  background-color: $navy;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 7px;
  color: #ffffff;
  z-index: 100;

  .update-filters-link {
    color: #0dd6c7;
    text-decoration: underline;
  }
}

.limit-error {
  display: flex;
  background-color: #fff6f6;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
  padding: 6px 0 8px 8px;

  .image-container {
    padding-top: 8px;
  }

  p.header {
    color: $blue;
    font-size: 14px;
    font-weight: bold;
    padding: 8px 0 0 8px;
    margin-bottom: 0px;
  }

  div {
    margin: 0 8px;
  }

  .clear-cache-link {
    color: $blue;
    cursor: pointer;
    padding-left: 8px;
    text-decoration: underline;
  }
}
</style>
